import styled from 'styled-components';

import { FlexDiv } from 'commonStyles';

export const Header = styled.div`
	font-size: 22px;
	line-height: 27px;
	padding: 26px 30px 11px;
	color: #000000;
	background: #ffffff;
	position: sticky;
	top: 0px;
`;

export const FilterContent = styled(FlexDiv)`
	padding: 8px 0px 12px 30px;
`;

export const OptionWrapper = styled(FlexDiv)`
	overflow:scroll;
	::-webkit-scrollbar {
		width: 0; 
		background: transparent;  
	}
	scrollbar-width: none;
	-ms-overflow-style: none;  
`;

export const Item = styled(FlexDiv)`
	padding: 8px 0;
	text-align: center;
	margin-top: 6px;
	&.up{
		width: 130px;
		border-radius: 4px;
	}
	&.over{
		width: auto;
		padding: 8px;
		margin-right: 8px;
		flex-shrink: 0;
		border-radius: 4px;
	}
	&.active {
		background: #FF664B;
		color: #ffffff;
	}
	&.inactive {
			background: #FFFFFF;
			border: 1px solid #D8D8D8;
			color: #4A4A4A;
	}
`;
